import { render, staticRenderFns } from "./SelectBoxItem.vue?vue&type=template&id=2aaf7e00&scoped=true"
import script from "./SelectBoxItem.vue?vue&type=script&lang=ts"
export * from "./SelectBoxItem.vue?vue&type=script&lang=ts"
import style0 from "./SelectBoxItem.vue?vue&type=style&index=0&id=2aaf7e00&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaf7e00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aaf7e00')) {
      api.createRecord('2aaf7e00', component.options)
    } else {
      api.reload('2aaf7e00', component.options)
    }
    module.hot.accept("./SelectBoxItem.vue?vue&type=template&id=2aaf7e00&scoped=true", function () {
      api.rerender('2aaf7e00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/SelectBoxItem.vue"
export default component.exports